/* Progressive enhancement: native dialogs, language-safe service links and policy hierarchy. */
(() => {
 document.addEventListener('click', e => {
  const option = e.target.closest('variant-picker label, variant-picker input, variant-picker select, variant-picker custom-select');
  if (option) { const info = option.closest('.product-info'); if (info) info.dataset.uxSizeChosen='true'; }
 });
 document.addEventListener('change', e => {
  if(e.target.closest('variant-picker')) { const info=e.target.closest('.product-info'); if(info) info.dataset.uxSizeChosen='true'; }
 });
 const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
 document.querySelectorAll('a[href^="/policies/"],a[href^="/pages/"]').forEach(a => {
  if (root) a.setAttribute('href', root + a.getAttribute('href'));
 });
 const policy = document.querySelector('.shopify-policy__body');
 if(policy && document.querySelector('#ux-policy-delivery')) policy.prepend(document.querySelector('#ux-policy-delivery').content.cloneNode(true));
 if (policy) policy.querySelectorAll('h1').forEach(h => {
  if (!h.textContent.trim()) { h.remove(); return; }
  const replacement = document.createElement('h2');
  replacement.innerHTML = h.innerHTML;
  h.replaceWith(replacement);
 });
 document.querySelectorAll('.shoe-size-guide').forEach(guide => {
  const dialog = guide.querySelector('dialog');
  guide.querySelector('.ux-size-open').addEventListener('click', () => dialog.showModal());
  guide.querySelector('.ux-size-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', e => { if (e.target === dialog) { const r=dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) dialog.close(); } });
 });
})();

const uxShoeFilterMemory = new Map();
if (!customElements.get('ux-shoe-filters')) customElements.define('ux-shoe-filters', class extends HTMLElement {
 connectedCallback() {
  requestAnimationFrame(() => {
   if (!this.isConnected || this.dataset.ready) return;
   this.cards = [...this.parentElement.querySelectorAll('product-card')];
   if(!this.cards.length || this.cards.some(c=>c.dataset.uxShoe!=='true')) return;
   this.dataset.ready='true';
   const sizes=[...new Set(this.cards.flatMap(c=>JSON.parse(c.dataset.uxSizes)))].sort((a,b)=>parseFloat(a)-parseFloat(b)||a.localeCompare(b));
   sizes.forEach(size=>{const o=document.createElement('option');o.value=size;o.textContent=size;this.querySelector('[data-filter="size"]').append(o);});
   this.selects=[...this.querySelectorAll('select')];
   const previous=uxShoeFilterMemory.get(location.pathname);
   if(previous) this.selects.forEach(s=>{const value=previous[s.dataset.filter]||'';if(value&&![...s.options].some(o=>o.value===value)){const o=document.createElement('option');o.value=value;o.textContent=value;s.append(o);}s.value=value;});
   this.selects.filter(s=>s.dataset.filter!=='size').forEach(s=>{
    const key=s.dataset.filter==='sport'?'uxSport':'uxAudience';
    [...s.options].filter(o=>o.value&&!this.cards.some(c=>c.dataset[key]===o.value)).forEach(o=>o.remove());
    if(s.options.length<=2)s.parentElement.hidden=true;
   });
   this.addEventListener('change',()=>this.apply());
   this.querySelector('[data-reset]').addEventListener('click',()=>{this.selects.forEach(s=>s.value='');this.apply();});
   this.hidden=false;this.apply();
  });
 }
 apply() {
  const values=Object.fromEntries(this.selects.map(s=>[s.dataset.filter,s.value]));uxShoeFilterMemory.set(location.pathname,values);let count=0;
  this.cards.forEach(c=>{
   const match=(!values.size||JSON.parse(c.dataset.uxSizes).includes(values.size))&&(!values.sport||c.dataset.uxSport===values.sport)&&(!values.audience||c.dataset.uxAudience===values.audience);
   c.closest('.js-pagination-result').hidden=!match;if(match)count++;
  });
  this.querySelector('[data-count]').textContent=count;
  this.querySelector('[data-empty]').hidden=count>0;
 }
});

if (!customElements.get('ux-cart-size')) customElements.define('ux-cart-size', class extends HTMLElement {
 connectedCallback() {
  if(this.dataset.ready)return;this.dataset.ready='true';
  this.querySelector('select').addEventListener('change', async e => {
   e.stopPropagation();
   const select=e.target, target=Number(select.value), status=this.querySelector('[role="status"]');
   const root=window.Shopify?.routes?.root||'/';
   const request=async(path,body)=>{const r=await fetch(root+path,{method:body?'POST':'GET',headers:{'Content-Type':'application/json'},...(body?{body:JSON.stringify(body)}:{})});const data=await r.json();if(!r.ok)throw new Error(data.description||'Cart error');return data;};
   select.disabled=true;status.textContent=this.dataset.pending;
   const cartScope=this.closest('cart-drawer')||this.closest('cart-items');
   const locked=[...cartScope.querySelectorAll('.cart-item input,.cart-item button,.cart-item select,button[name=checkout]')].filter(el=>!el.disabled);
   locked.forEach(el=>el.disabled=true);
   let added=null, prior=0;
   try {
    const cart=await request('cart.js');
    const old=cart.items.find(i=>i.key===this.dataset.lineKey);
    if(!old)throw new Error('Cart changed');
    const existing=cart.items.find(i=>i.variant_id===target&&!Object.keys(i.properties||{}).length&&!i.selling_plan_allocation);
    prior=existing?.quantity||0;
    // Shopify add validates current availability before the old line is removed.
    added=await request('cart/add.js',{id:target,quantity:old.quantity});
    await request('cart/change.js',{id:old.key,quantity:0});
   } catch(error) {
    if(added) {
     try { await request('cart/change.js',{id:added.key,quantity:prior}); }
     catch(rollbackError) { /* Reload below reveals the authoritative cart after any concurrent change. */ }
    }
    sessionStorage.setItem('ux-cart-edit-error',this.dataset.error);
   }
   locked.forEach(el=>el.disabled=false);
   const cartItems=this.closest('cart-items');
   if(cartItems?.refresh)await cartItems.refresh();else location.reload();
   const message=sessionStorage.getItem('ux-cart-edit-error');
   if(message){sessionStorage.removeItem('ux-cart-edit-error');const alert=document.querySelector('#cart-errors');if(alert){alert.textContent=message;alert.hidden=false;}else window.alert(message);}
  });
 }
});

// Supplement existing commerce analytics; do not duplicate Shopify purchase/cart events.
(() => {
 const emit=(action,extra={})=>{
  if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true)return;
  window.dataLayer=window.dataLayer||[];
  window.dataLayer.push({event:'afp_ux_interaction',ux_action:action,ux_language:document.documentElement.lang,ux_device:matchMedia('(max-width:768px)').matches?'mobile':'desktop',...extra});
 };
 document.addEventListener('click',e=>{
  if(e.target.closest('.ux-size-open'))emit('size_guide_open');
  if(e.target.closest('.js-trigger-compare'))emit('compare_open');
 });
 document.addEventListener('change',e=>{
  if(e.target.closest('ux-shoe-filters'))emit('shoe_filter',{ux_filter:e.target.dataset.filter,ux_filter_value:e.target.value});
  if(e.target.closest('variant-picker'))emit('variant_selection');
 });
})();

// Exact, curated aliases only: preserve all other searches unchanged.
document.addEventListener('submit', event => {
 const input=event.target.querySelector('input[name="q"]');if(!input)return;
 const aliases={'מטאלבון':'Metalbone','מטלבון':'Metalbone','metalbon':'Metalbone','metlabone':'Metalbone','קרוס איט':'Cross It','crossit':'Cross It'};
 const canonical=aliases[input.value.trim().toLowerCase()];if(canonical)input.value=canonical;
},true);
